(function () {
  const webhookUrl = 'https://start.automatisierung.dev/webhook/oxylythe-hallo10';

  document.addEventListener(
    'submit',
    function (event) {
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;
      if (!form.classList.contains('newsletter-form')) return;

      const input = form.querySelector('input[type="email"]');
      const email = input && String(input.value || '').trim();
      if (!email) return;

      const body = new URLSearchParams({
        email: email,
        source: form.id || 'newsletter',
      });

      try {
        if (navigator.sendBeacon) {
          navigator.sendBeacon(webhookUrl, body);
          return;
        }
      } catch (error) {
        // Fall through to fetch.
      }

      try {
        fetch(webhookUrl, {
          method: 'POST',
          body: body,
          keepalive: true,
          mode: 'cors',
        });
      } catch (error) {
        // Signup still goes to Shopify; HALLO10 mail is best-effort.
      }
    },
    true
  );
})();
